import React, { Fragment, useEffect } from "react";
import { AddonsWrapper, Heading, Wrapper } from "./Addons.styles";
import Check from "../../../../../components/Checkbox/Check";
import AutoCompleteSelect from "../../../../../components/AutoCompleteSelect/AutoComplete";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import useUrlQuerys from "../../../../../hooks/useUrlsQuerys";
import { useGetAddonsQuery } from "../../../../../services/QuoteServices";
import {
    setSelectedAddons,
    removeAddon,
    setAddOnsWithCover,
} from "../../../../../modules/quotes.slice";
import { useLocation, useNavigate } from "react-router-dom";
import { useFilterMutation, useGetEligibleProductsQuery } from "../../../../../services/CarServices";
import { StyledButton } from "../../../../../components/Button/Button";

const Addons: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { get, set } = useUrlQuerys();
    const { selectedAddons, addOnsWithCover } = useTypedSelector((state) => state.quote);
    const { updateFilter } = useFilterMutation();
    const { requestData } = useGetEligibleProductsQuery();
    const { addons_list = [] } = useGetAddonsQuery();
    const location = useLocation();

    const registrationYear = requestData?.registration_date
        ? new Date(requestData?.registration_date).getFullYear()
        : "";
    const isEveryZero = Object.values(addOnsWithCover).every((item) => !item);

    useEffect(() => {
        if (!addons_list || addons_list.length === 0) return;

        const param = get("addOns");
        if (!param) return;

        const ids = param
            .split(",")
            .map((id) => parseInt(id))
            .filter((id) => !isNaN(id));

        ids.forEach((id) => {
            const addon = addons_list.find((a: any) => a.ADD_ON_ID === id);
            if (!addon) return;

            dispatch(setSelectedAddons(addon.ADD_ON_SLUG));

            if (addon.IS_SI_REQUIRED === "Y" && addon.ALLOWED_SI) {
                const firstSI = addon.ALLOWED_SI.split(",")[0];
                dispatch(
                    setAddOnsWithCover({
                        key: addon.ADD_ON_SLUG,
                        value: Number(firstSI),
                    })
                );
            }
        });
    }, [addons_list]);

    const updateQueryParam = (updatedSlugs: string[]) => {
        const ids = addons_list
            .filter((a: any) => updatedSlugs.includes(a.ADD_ON_SLUG))
            .map((a: any) => a.ADD_ON_ID);
        navigate(`/quotes?${set("addOns", ids.join(","))}`, { replace: true });
    };

    const handleCheckboxClick = (
        slug: string,
        addonId: number,
        isSIRequired: string,
        allowedSI: string | null
    ) => {
        const isSelected = selectedAddons.includes(slug);

        let updatedSlugs = [...selectedAddons];

        if (isSelected) {
            dispatch(removeAddon(slug));
            dispatch(setAddOnsWithCover({ key: slug, value: undefined }));
            updatedSlugs = updatedSlugs.filter((s) => s !== slug);
        } else {
            dispatch(setSelectedAddons(slug));
            updatedSlugs.push(slug);
            if (isSIRequired === "Y") {
                const firstSI = allowedSI?.split(",")[0] || "1000";
                dispatch(setAddOnsWithCover({ key: slug, value: Number(firstSI) }));
            }
        }

        updateQueryParam(updatedSlugs);
    };

    return (
        <Wrapper>
            <Heading>Select Addons & Accessories</Heading>
            <AddonsWrapper className="min-h-64">
                {addons_list.map((item: any) => (
                    <Fragment key={item.ADD_ON_SLUG}>
                        <Check
                            label={item.ADD_ON_NAME}
                            value={item.ADD_ON_ID}
                            checked={selectedAddons.includes(item.ADD_ON_SLUG) || addOnsWithCover[item.ADD_ON_SLUG]}
                            onClick={() =>
                                handleCheckboxClick(
                                    item.ADD_ON_SLUG,
                                    item.ADD_ON_ID,
                                    item.IS_SI_REQUIRED,
                                    item.ALLOWED_SI
                                )
                            }
                            primary={undefined}
                            labelStyle={undefined}
                            checkBoxStyle={undefined}
                        />

                        {item.IS_SI_REQUIRED === "Y" &&
                            selectedAddons.includes(item.ADD_ON_SLUG) && (
                                <AutoCompleteSelect
                                    options={item.ALLOWED_SI?.split(",") || []}
                                    label="Cover"
                                    size="medium"
                                    selectedValue={addOnsWithCover[item.ADD_ON_SLUG]}
                                    customInput={{ min: 1, max: 10 }}
                                    handleChange={(val: any) => {
                                        dispatch(setAddOnsWithCover({ key: item.ADD_ON_SLUG, value: val }));
                                    }}
                                    _key={undefined}
                                    getOptionLabel={undefined}
                                    getOptionSelected={undefined}
                                    loading={undefined}
                                    error={undefined}
                                />
                            )}
                    </Fragment>
                ))}

                {Object.keys(addOnsWithCover).length > 0 && !isEveryZero && (
                    <div className="w-full-flex-center-mt-20">
                        <StyledButton
                            variant="contained"
                            onClick={() => {
                                updateFilter({
                                    ...requestData,
                                    ...addOnsWithCover,
                                    vehicle_registration_year: registrationYear,
                                });
                            }}
                        >
                            Apply
                        </StyledButton>
                    </div>
                )}
            </AddonsWrapper>
        </Wrapper>
    );
};
export default Addons;
